var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrint(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconPrint_svg__clip0_5652_7598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 8H5c-1.655 0-3 1.345-3 3v6h4v4h12v-4h4v-6c0-1.655-1.345-3-3-3zm-3 11H8v-5h8v5zm3-7c-.555 0-1-.445-1-1 0-.555.445-1 1-1 .555 0 1 .445 1 1 0 .555-.445 1-1 1zm-1-9H6v4h12V3z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconPrint_svg__clip0_5652_7598"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/IconPrint.033f60da.svg";
export { MemoForwardRef as ReactComponent };